module.exports = __webpack_public_path__ + "static/img/hr-drive-included.61e962f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/hr-drive-included.png
// module id = +NBl
// module chunks = 0